import { Injectable } from '@angular/core';
import CodiceFiscale from 'codice-fiscale-js';
@Injectable({ providedIn: 'root' })
export class FiscalCodeService {
 generateFiscalCode(data: {
   firstName: string;
   lastName: string;
   gender: 'M' | 'F';
   birthDate: Date;
   birthCity: string;
   birthProvince: string;
 }): string {
   return CodiceFiscale.compute({
     name: data.firstName,
     surname: data.lastName,
     gender: data.gender,
     day: data.birthDate.getDate(),
     month: data.birthDate.getMonth() + 1,
     year: data.birthDate.getFullYear(),
     birthplace: data.birthCity,
     birthplaceProvincia: data.birthProvince,
   });
 }
 extractData(fiscalCode: string) {
   return new CodiceFiscale(fiscalCode);
 }
 isFiscalCodeValid(fiscalCode: string): boolean {
   return CodiceFiscale.check(fiscalCode);
 }
}